import { createFileRoute } from '@tanstack/react-router';
import { OverviewTab } from '@/features/carriers/detail/overview-tab';

// S11 · Carrier overview (07 §4).
export const Route = createFileRoute('/_app/carriers/$code/')({
  component: OverviewTab,
});
